export default "__VITE_ASSET__52683703__"